export default __webpack_public_path__ + "static/media/12.6a05bb9d.png";